import logoNoronCar from '../Images/logo.png'
import config from "../config.json";
import "./Register.css";
import loginLogo from '../Images/logoWeb.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import AddImage from '../Images/AddImage.png'
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function PersonData() {
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)

    const backgroundCardMeli = useRef(null);
    const picCardMeli = useRef(null);

    const backgroundCode = useRef(null);
    const picCode = useRef(null);

    const backgroundMovafegh = useRef(null);
    const picMovafegh = useRef(null);

    const backgroundPersoneli = useRef(null);
    const picPersoneli = useRef(null);

    const [form, setForm] = useState({ id: 0, name: "", family: "" })
    const loadData = async () => {
        setIsLoading(true);
        await service.OzveGet()
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setForm(data.payload);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        loadData()
    }, []);

    useEffect(() => {
        if (isLoading || form.id<=0)
            return;
        // console.log('111');
        // console.log('111',backgroundPersoneli);
         backgroundPersoneli.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}.jpg?${new Date().getTime()})`;
        //backgroundPersoneli.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}&${new Date().getTime()})`;
        //console.log('222');
        backgroundCardMeli.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_0.jpg?${new Date().getTime()})`;
        //backgroundCardMeli.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_0&${new Date().getTime()})`;
        backgroundCode.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_1.jpg?${new Date().getTime()})`;
        //backgroundCode.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_1&${new Date().getTime()})`;
        backgroundMovafegh.current.style.backgroundImage = `url(${config.apiUrl}/picture/${form.id}_2.jpg?${new Date().getTime()})`;
        //backgroundMovafegh.current.style.backgroundImage = `url(${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${form.id}_2&${new Date().getTime()})`;
      
    }, [isLoading,form.id]);



    const formRef = useRef(null);
    return (
        <>
            <div className="container  d-flex align-items-center justify-content-center">
                <div className="w-100">
                    <div className="row mt-2 ">
                        <div className="col d-flex  justify-content-center">
                            <img src={loginLogo} className="img-fluid logoRegister" alt="logoRegister" />
                        </div>
                    </div>
                    <div className="row mt-3 ">
                        <div className="col fs-5 text-color1 fw-bold d-flex  justify-content-center">
                            کانون بازنشستگان همدان
                        </div>
                    </div>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>}
                    {!isLoading &&
                        <form ref={formRef} className=" needs-validation border rounded p-3 mt-3 shadow" >
                            <div className="row mt-3">
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">کد ملی</label>
                                        <input disabled
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            required
                                            value={form.codeMeli}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="codeMeli" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">شماره موبایل</label>
                                        <input disabled
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            required
                                            value={form.mobile}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="mobile" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">شماره مستمری</label>
                                        <input disabled
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            required
                                            value={form.mostamariCode}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="mostamariCode" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">نام</label>
                                        <input disabled
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            required
                                            value={form.name}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="name" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">نام خانوادگی</label>
                                        <input disabled
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            required
                                            value={form.family}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="family" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">نام پدر</label>
                                        <input disabled
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={form.nameFather}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="nameFather" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">شماره شناسنامه</label>
                                        <input disabled
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            value={form.code}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="code" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">سریال شناسنامه</label>
                                        <input disabled
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={form.seriall}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="seriall" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">تاریخ تولد</label>
                                        <input disabled
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={form.birthDay}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="birthDay" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">تلفن ثابت</label>
                                        <input disabled
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            value={form.telfix}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="telfix" />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="mb-3">
                                        <label className="form-label">آدرس</label>
                                        <textarea
                                            disabled
                                            rows="3"
                                            className="form-control"
                                            placeholder=""
                                            value={form.address}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="address" />
                                    </div>
                                </div>
                                <div className='col-auto border rounded m-2   '
                                    style={{ backgroundSize: "cover" }}
                                    ref={backgroundPersoneli}>
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundPersoneli, "personeliPic") }}
                                        ref={picPersoneli}
                                    />

                                    <div className='row p-4 '>
                                        <div className='col justify-content-center align-items-center text-center' >
                                            <div>
                                                <Link
                                                    to=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        // picPersoneli.current.click()
                                                    }}>
                                                    {/*<img src={AddImage} />*/}
                                                </Link>
                                            </div>
                                            عکس پرسنلی
                                        </div>
                                    </div>

                                </div>

                                <div className='col-auto border rounded m-2   '
                                    style={{ backgroundSize: "cover" }}
                                    ref={backgroundCardMeli}>
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundCardMeli, "cardMeliPic") }}
                                        ref={picCardMeli}
                                    />

                                    <div className='row p-4 '>
                                        <div className='col justify-content-center align-items-center text-center' >
                                            <div>
                                                <Link
                                                    to=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        //   picCardMeli.current.click()
                                                    }}>
                                                    {/*<img src={AddImage} />*/}
                                                </Link>
                                            </div>
                                            تصویر کارت ملی
                                        </div>
                                    </div>
                                </div>
                                <div className='col-auto border rounded m-2   '
                                    style={{ backgroundSize: "cover" }}
                                    ref={backgroundCode}>
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        // onChange={(e) => { upload(e, backgroundCode, "codePic") }}
                                        ref={picCode}
                                    />
                                    <div className='row p-4 '>
                                        <div className='col justify-content-center align-items-center text-center' >
                                            <div>
                                                <Link
                                                    to=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        //  picCode.current.click()
                                                    }}>
                                                    {/*<img src={AddImage} />*/}
                                                </Link>
                                            </div>
                                            تصویر شناسنامه
                                        </div>
                                    </div>
                                </div>
                                <div className='col-auto border rounded m-2   '
                                    style={{ backgroundSize: "cover" }}
                                    ref={backgroundMovafegh}>
                                    <input disabled
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        //onChange={(e) => { upload(e, backgroundMovafegh, "movafeghPic") }}
                                        ref={picMovafegh}
                                    />
                                    <div className='row p-4 '>
                                        <div className='col justify-content-center align-items-center text-center' >
                                            <div>
                                                <Link
                                                    to=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        //picMovafegh.current.click()
                                                    }}>
                                                    {/*<img src={AddImage} />*/}
                                                </Link>
                                            </div>
                                            تصویر حکم بازنشستگی
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    }
                    <div className="row mt-4 mb-4 ">
                        <div className="col d-flex  justify-content-center">
                            <Link to="/main" ><img src={logoNoronCar} className="img-fluid rounded-circle iconLink mx-2 shadow" alt="logoWeb" />بازگشت</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );

}
